import { writable } from 'svelte/store';
import * as equivalentsApi from '../api/equivalents';
const parsedEquivalent = writable(null);
async function getEquivalents(kilosCo2, equivalent) {
    const data = await equivalentsApi.getEquivalents({ equivalent, kilosCo2, language: 'en' });
    parsedEquivalent.set(data.text);
    return data;
}
export { parsedEquivalent, getEquivalents };
